import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/services/auth/auth.service";
import { Role } from "src/services/user/role.enum";

export const IsAdminGuard = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const currentUser = await authService.getActiveUser();

  if (currentUser?.role === Role.admin) {
    return true;
  } else {
    const target = "/";

    await router.navigate([target]);
    return false;
  }
};
